import React from 'react'
import withView from '../../../cmn/docAutomation/withView';
import SarasTrans from '../../../../library/notifications/SarasTrans';
import FormButton from '../../../../library/form/components/FormActionButton2';
import FormROValue from '../../../../library/form/components/FormROValue1';
import FormLink from '../../../../library/form/components/FormLink';
import FormWrapper from '../../../../library/form/components/FormWrapper'
import FormLabel from '../../../../library/form/components/FormLabel'
import FormTitle from '../../../../library/form/components/FormTitle'
import { UiView, UiViewHeading, UiTitle, UiAction, UiViewContent, UiGridColOne, UiCol } from "../../../../library/layout/Index";
import DocAdminInfo from '../../../cmn/DocAdminInfo';

const VoucherHeaderViewer = (props) => {
    const { formObject } = props;

    return (
        <UiView>
            <UiViewHeading>
                <UiTitle>
                    <span>
                        <FormTitle formObject={formObject} value='Voucher Detail' />
                    </span>
                </UiTitle>

                <UiAction>
                    <DocAdminInfo formObject={formObject} rowKey="" headerKey="adminInfo"/>
                    <FormButton formObject={formObject} rowKey="" 
                        confirm="Are you sure all data is correct ?"
                        action={{ actionId: "refresh", refreshMode:"dep", 
                        actionMessage: "PleaseWait",
                        paramName: "odooSynch", actionParam: {actionType: "odoo"}, containerKey: "popup" }}
                        className="uiActionButtonBlue" text={<SarasTrans value="Send to Odoo" />}></FormButton>
                    <FormButton formObject={formObject} ksc="h" rowKey="" starIcon={"edit"}
                                action={{ actionId: "edit",  actionParam: {}, containerKey: "popup" }}
                                className="uiActionIconButton" text={<SarasTrans value="Edit" />}></FormButton>
                </UiAction>

            </UiViewHeading>
            <UiViewContent>
                <UiGridColOne>
                    <UiCol>
                        <ul>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "docID" }} value="ID" />
                                </span>
                                <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "docID" }} className="uiVal uiHighlightKey" />
                            </li>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "docCode" }} value="Document Code" />
                                </span>
                                <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "docCode" }} className='uiVal' />
                            </li>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "profile" }} value="" />
                                </span>
                                <FormLink formObject={formObject} rowKey="" className="uiLink"
                                    action={{ paramName: "profile", actionId: "show",  containerKey: "popup" }}
                                    linkProp={{ target: "_blank" }}
                                ></FormLink>
                            </li>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "refNumber" }} value="Reference Number" />
                                </span>
                                <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "refNumber" }} className="uiVal" />
                            </li>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "remarks" }} value="Remarks" />
                                </span>
                                <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "remarks" }} className="uiVal" />
                            </li>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "paymentMode" }} value="Payment Mode" />
                                </span>
                                <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "paymentMode" }} className="uiVal" />
                            </li>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "paymentDtl" }} value="Payment Detail" />
                                </span>
                                <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "paymentDtl" }} className="uiVal" />
                            </li>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "chargeType" }} value="Charge Type" />
                                </span>
                                <span className="uiVal" id="svChargeType"  />
                                <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "chargeType" }} className="uiVal" />
                            </li>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "chargePercent" }} value="Charge %" />
                                </span>
                                <FormROValue format="" formObject={formObject} rowKey="" action={{ paramName: "chargePercent" }} className="uiVal" />
                            </li>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "lastPaidOn" }} value="Last Paid Date" />
                                </span>
                                <FormROValue format="" formObject={formObject} rowKey="" action={{ paramName: "lastPaidOn" }} className="uiVal" />
                            </li>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "totalOutstanding" }} value="Outstanding" />
                                </span>
                                <FormROValue format="" formObject={formObject} rowKey="" action={{ paramName: "totalOutstanding" }} className="uiVal uiHighlightBlue" />
                            </li>
                            <FormWrapper customWrapper="li" formObject={formObject} rowKey="" action={{ paramName: "billFromDate" }} >
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "billFromDate" }} value="Bill From Date" />
                                </span>
                                <FormROValue format="" formObject={formObject} rowKey="" action={{ paramName: "billFromDate" }} className="uiVal" />
                            </FormWrapper>
                            <FormWrapper customWrapper="li" formObject={formObject} rowKey="" action={{ paramName: "billToDate" }} >
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "billToDate" }} value="Bill To Date" />
                                </span>
                                <FormROValue format="" formObject={formObject} rowKey="" action={{ paramName: "billToDate" }} className="uiVal" />
                            </FormWrapper>
                            <FormWrapper customWrapper="li" formObject={formObject} rowKey="" action={{ paramName: "journalName" }} >

                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "journalName" }} value="Journal" />
                                </span>
                                <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "journalName" }} className='uiVal' />
                            </FormWrapper>
                        </ul>
                    </UiCol>
                </UiGridColOne>
            </UiViewContent>
        </UiView>
    )
}

export default withView(VoucherHeaderViewer, "voucherHead", "apiLog");